<template>
  <div class="login-box">
    <div class="login-logo">
      <router-link to="/">
        <b>Mister</b> Aladin
      </router-link>
    </div>
    <!-- /.login-logo -->
    <div class="login-box-body">
      <p class="login-box-msg">Forgot your password? No problem we will send your password.</p>
      <form @submit.prevent="submit">
        <div v-if="errorMessage" class="alert alert-danger">
          <a class="close" @click="errorMessage = false">&times;</a>
          {{ errorMessage }}
        </div>

        <div class="form-group has-feedback">
          <input type="text" class="form-control" placeholder="Email" v-model="credentials.email">
          <span class="glyphicon glyphicon-user form-control-feedback"></span>
        </div>
        <div class="row">
          <div class="col-xs-8">
            <router-link to="/login">Kembali ke halaman login</router-link>
          </div>
          <!-- /.col -->
          <div class="col-xs-4">
            <button type="submit" class="btn btn-primary btn-block btn-flat">Submit</button>
          </div>
          <!-- /.col -->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      credentials: {
        email: null,
      },
      errorMessage: null,
    };
  },
  methods: {
    submit() {
      this.axios
        .post('/auth/password/email', qs.stringify(this.credentials))
        .then((response) => {
          console.log('Success', response.data);
          this.credentials.email = null;
          this.$swal('Success', 'Reset link has been sent to your email.', 'success');
        })
        .catch((error) => {
          console.log('Error', error.response.data.errors);
          this.$swal('Error', error.response.data.errors, 'error');
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Forgot.vue